import { useState } from "react";
import { Play } from "lucide-react";
import { SectionHead } from "@/components/site/SectionHead";

// Paste a YouTube/Vimeo embed URL here to replace the placeholder.
const VIDEO_EMBED_URL = "";

export const IntroVideo = () => {
  const [tapped, setTapped] = useState(false);
  return (
    <section id="intro-video" className="relative py-20 sm:py-24 md:py-32 btr-bg-glow overflow-hidden" data-testid="intro-video-section">
      <div className="relative max-w-6xl mx-auto px-6">
        <SectionHead
          className="max-w-3xl mx-auto text-center"
          badge="Intro Film"
          title={<>See how we work <span className="text-[#a2020b]">before</span> the risk.</>}
        />
        <div className="btr-reveal mt-12 relative aspect-video rounded-2xl overflow-hidden border border-white/10 bg-black" data-testid="intro-video-frame">
          {VIDEO_EMBED_URL ? (
            <iframe src={VIDEO_EMBED_URL} title="Before The Risk introduction" className="absolute inset-0 w-full h-full" allow="autoplay; fullscreen; picture-in-picture" allowFullScreen />
          ) : (
            <button type="button" onClick={() => setTapped(true)} className="group absolute inset-0 w-full h-full" data-testid="intro-video-play">
              <img src="/branding-bg-1920x1080.png" alt="" loading="lazy" decoding="async" className="absolute inset-0 w-full h-full object-cover opacity-70 transition-transform duration-[1600ms] group-hover:scale-[1.04]" />
              <div className="absolute inset-0 bg-gradient-to-t from-black via-black/30 to-transparent" />
              <span className="absolute inset-0 flex items-center justify-center">
                <span className="w-20 h-20 sm:w-24 sm:h-24 rounded-full bg-[#a2020b] flex items-center justify-center shadow-[0_0_60px_rgba(162,2,11,0.7)] transition-transform group-hover:scale-110">
                  <Play className="w-8 h-8 text-white ml-1" fill="currentColor" />
                </span>
              </span>
              <span className="absolute bottom-5 left-6 right-6 flex items-center justify-between text-left">
                <span className="font-display text-[11px] tracking-[0.3em] uppercase text-zinc-300">Before The Risk · Introduction</span>
                <span className="font-display text-[11px] tracking-[0.3em] uppercase text-[#ff4d55]" data-testid="intro-video-status">
                  {tapped ? "Premiering soon" : "Coming soon"}
                </span>
              </span>
            </button>
          )}
        </div>
      </div>
    </section>
  );
};
